import Dialog from "@/components/cowork/common/alertMessage/Dialog";
export default {
    install(Vue) {

        Vue.prototype.showConfirmDialogWithJSON = function(reqModalParam) {
            let _modalParam = {
                name: reqModalParam.name,
                modalSize: reqModalParam.modalSize, 
                confirmTitle: reqModalParam.confirmTitle, 
                confirmMessage: reqModalParam.confirmMessage, 
                confirmBtnText: reqModalParam.confirmBtnText, 
                confirmBtnCallback: reqModalParam.confirmBtnCallback, 
                modalParam: reqModalParam.modalParam, 
                cancelBtnText: reqModalParam.cancelBtnText, 
                cancelBtnCallback: reqModalParam.cancelBtnCallback,
                autoFocus: reqModalParam.autoFocus
            };
            this.showConfirmDialog(_modalParam.modalSize, _modalParam.confirmTitle, _modalParam.confirmMessage, _modalParam.confirmBtnText, _modalParam.confirmBtnCallback, _modalParam.modalParam, _modalParam.cancelBtnText, _modalParam.cancelBtnCallback, _modalParam.name, _modalParam.autoFocus);
        }

        /* required ...mapActions("modals", ["showModal"])
        modalSize default width: 400px, height: 180px
        modal title default '확인'
        message default ''
        confirm text default '확인'
        confirm function default $emit.close
        cancel text default '취소'
        cancel function default $emit.close
        Example) this.showConfirmDialog(null, '모달팝업타이틀', '모달메세지', '확인버튼명', '확인 콜백이벤트', '취소버튼명', '취소 콜백이벤트')
        */
       Vue.prototype.showConfirmDialog = function(modalSize, confirmTitle, confirmMessage, confirmBtnText, confirmBtnCallback, modalParam, cancelBtnText, cancelBtnCallback, name, autoFocus) {
           
            name = name || 'showConfirmDialog';
            confirmTitle = confirmTitle || this.$i18nUtil.trans("title.dialog.notice", "알림");
            confirmMessage = confirmMessage || '';
            confirmBtnText = confirmBtnText || this.$t("button.dialog.confirm"), "확인";
            cancelBtnText = cancelBtnText || this.$t("button.dialog.cancel", "취소");
            confirmBtnCallback = confirmBtnCallback || null;
            cancelBtnCallback = cancelBtnCallback || null;
            modalSize = modalSize || {width: "400px"};
            autoFocus = autoFocus == null ? true : autoFocus;
            modalParam = modalParam || {};
            const modalInfo = {
                name: name,
                title: confirmTitle,
                width: modalSize.width,
                height: modalSize.height,
                obj: this.$modal,
                contents: confirmMessage,
                modalParam: modalParam,
                autoFocus: autoFocus,
                button: confirmBtnText,
                buttonCallback: confirmBtnCallback,
                subButton: cancelBtnText,
                subButtonCallback: cancelBtnCallback,
                component: Dialog,
            };
            this.showModal(modalInfo);
        }

        /* required ...mapActions("modals", ["showModal"])
         alertMessage: 알림메세지 default ''
         alertTitle: 알림 모달 타이틀 default: '알림'
         modalSize: default width: 400px, height: 180px
         alertBtnText: 확인 버튼명 default: '확인'
         alertBtnCallback: 확인 버튼 콜백 default: $emit.close
         Example) this.showAlertDialog('모달메세지', '모달팝업타이틀', {width: "400px", height: "180px"}, '확인버튼명', '확인 콜백이벤트')
        */
        Vue.prototype.showAlertDialog = function(alertMessage, alertTitle, modalSize, alertBtnText, alertBtnCallback, autoFocus) {
            
            alertTitle = alertTitle || this.$i18nUtil.trans("title.dialog.notice", "알림");
            alertMessage = alertMessage || '';
            alertBtnText = alertBtnText || this.$t("button.dialog.confirm"), "확인";
            alertBtnCallback = alertBtnCallback || function(){};
            modalSize = modalSize || {width: "400px"};
            autoFocus = autoFocus == null ? true : autoFocus;
            const modalInfo = {
                title: alertTitle,
                width: modalSize.width,
                height: modalSize.height,
                obj: this.$modal,
                contents: alertMessage,
                autoFocus: autoFocus,
                button: alertBtnText,
                buttonCallback: alertBtnCallback,
                component: Dialog,
            };
            this.showModal(modalInfo);
        }
    }
}


// WEBPACK FOOTER //
// ./src/js/store/module/common/confirmDialog.js